import { render, staticRenderFns } from "./Overviewitem.vue?vue&type=template&id=61ddba8b&scoped=true&"
import script from "./Overviewitem.vue?vue&type=script&lang=js&"
export * from "./Overviewitem.vue?vue&type=script&lang=js&"
import style0 from "./Overviewitem.vue?vue&type=style&index=0&id=61ddba8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ddba8b",
  null
  
)

export default component.exports